import React from 'react';
import { Linking } from 'react-native';
import { useTheme } from 'react-native-paper';
import { Maybe, Transaction } from '../../types/appsync-types';
import Typography from '../../components/Typography';
import { useI18n } from '../../context/I18nContext';
import { listIconGenerator } from '../../components/SimpleListIcon';
import { ListItemRow } from '../../components/ListItemRow';

interface TransactionListProps {
  transactions: Maybe<Transaction>[];
}

export const TransactionList = ({ transactions }: TransactionListProps) => {
  const { I18n, formatCurrency, formatDate, formatDateRange } = useI18n();
  const { colors } = useTheme();

  return [...transactions]
    .sort((a, b) => (b?.paymentTime ?? 0) - (a?.paymentTime ?? 1))
    .map((item) => {
      const refundText = item?.refundTime
        ? `\n${I18n.t('payment.receipts.refunded')}: ${formatDate(
            new Date(item.refundTime * 1000),
            'dateWithYear',
            'Europe/Helsinki',
          )}`
        : '';
      return (
        <ListItemRow
          key={item?.id}
          title={() => (
            <Typography variant="body1">
              {item?.productName}
              {item?.price && (
                <Typography variant="body1">
                  {' • '}
                  <Typography variant="body1" color={colors.primary} style={{ fontWeight: 'bold' }}>
                    {formatCurrency(item?.price, item?.currency || 'EUR')}
                  </Typography>
                </Typography>
              )}
            </Typography>
          )}
          description={`${formatDateRange(
            new Date(item?.startTime! * 1000),
            new Date(item?.endTime! * 1000),
            'timeAndDate',
            'Europe/Helsinki',
          )}\n${I18n.t('payment.receipts.paid')}: ${formatDate(
            new Date(item?.paymentTime! * 1000),
            'dateWithYear',
            'Europe/Helsinki',
          )}${refundText}`}
          titleNumberOfLines={2}
          descriptionNumberOfLines={3}
          right={listIconGenerator('link')}
          onPress={() => {
            if (item?.receiptUrl) {
              Linking.openURL(item.receiptUrl);
            }
          }}
          leftIcon={'doc'}
        />
      );
    });
};
